import { events } from "@/constants";
import { on } from "@/neon/events";
import reviewsDrawer from "@/components/reviewsDrawer";

const selectors = {
  reviewsFlyout: "[data-reviews-drawer]",
  reviewsContainers: ".product__reviews",
  reviewStars: ".product__reviews-stars",
  reviewsTriggers: ".product__reviews-trigger",
};

const reviews = (node, isDrawer = false) => {
  const reviewsContainers = node.querySelectorAll(selectors.reviewsContainers);
  const reviewsFlyout = node.querySelector(selectors.reviewsFlyout);
  const reviewsTriggers = node.querySelectorAll(selectors.reviewsTriggers);

  const _handleReviewsTrigger = e => {
    e.preventDefault();

    if (drawer) {
      drawer.open();
    } else {
      const reviewsContainer = document.querySelector(
        "#shopify-product-reviews"
      );
      if (reviewsContainer) {
        reviewsContainer.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  // const _addReviewStars = stars => {
  //   reviewsContainers.forEach(container => {
  //     const reviewStars = container.querySelector(selectors.reviewStars);

  //     if (stars) {
  //       const starRating = stars.cloneNode(true);

  //       reviewStars.classList.remove('hidden');
  //       reviewStars.appendChild(starRating);
  //     }
  //   });
  // };

  // const _addReviewDrawerTrigger = totalReviews => {
  //   reviewsTriggers.forEach(trigger => {
  //     trigger.style.display = '';
  //     trigger.innerText = totalReviews;
  //   });
  // };

  reviewsTriggers.forEach(trigger => {
    trigger.addEventListener("click", _handleReviewsTrigger);
  });

  // const reviewsListener = on(
  //   events.reviews.added,
  //   ({ starRating, totalReviews }) => {
  //     _addReviewDrawerTrigger(totalReviews);
  //     _addReviewStars(starRating);

  //     reviewsContainers.forEach(container => {
  //       container.classList.remove('hidden');
  //     });
  //   }
  // );

  let drawer = null;

  if (isDrawer) {
    drawer = reviewsDrawer(reviewsFlyout);
  }

  const unload = () => {
    // reviewsListener();
    drawer && drawer.unload();

    reviewsTriggers.forEach(trigger => {
      trigger.removeEventListener("click", _handleReviewsTrigger);
    });
  };

  return { unload };
};

export default reviews;
